import React from 'react';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { Avatar, Box } from '@mui/material';

import { theme } from '@itp/talent/theme';

import type { NotificationType } from './types';

import { BodyText, BodyTextSmall } from '../../core/typography';
import { useNotificationContent } from './useNotificationContent';

dayjs.extend(relativeTime);

const GeneralNotification: React.FC<{ notification: NotificationType }> = ({ notification }) => {
  const timeAgo = dayjs(notification.createdAt).fromNow();
  const content = useNotificationContent(notification);
  return (
    <Box
      alignItems="flex-start"
      display="flex"
      flexDirection="column"
      gap={theme.spacing(1)}
      width="100%"
    >
      <Box alignItems="flex-start" display="flex" gap={theme.spacing(2)} width="100%">
        <Avatar
          src={
            notification.from?.profile?.profilePicture?.optimizedUrl ||
            notification.from?.profile?.profilePicture?.originalUrl
          }
          sx={{ height: 32, width: 32 }}
        />
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          sx={{ '& a': { color: theme.palette.primary.main } }}
        >
          <BodyText dangerouslySetInnerHTML={{ __html: content }} />
          <BodyTextSmall color={theme.palette.text.secondary} variant="caption">
            {timeAgo}
          </BodyTextSmall>
        </Box>
      </Box>
    </Box>
  );
};
export default GeneralNotification;
